// Two cuts of the same lockup. The wordmark's "SKY" is cloud-white, which
// disappears on a white page, so the light scheme gets a version with that half
// repainted in deep navy; "STAKE" and the cloud stay brand blue in both.
export const LOGO_DEFAULT_SRC = "/logo.png";
export const LOGO_LIGHT_SRC = "/logo-light.png";

/** The lockup reduced to its first glyph - the S standing on its cloud. */
export const LOGO_MOBILE_DEFAULT_SRC = "/logo-mark.png";
export const LOGO_MOBILE_LIGHT_SRC = "/logo-mark-light.png";

// Intrinsic sizes of the PNGs, so the browser reserves the right box before they load.
export const LOGO_FULL_SIZE = { width: 720, height: 115 };
export const LOGO_MOBILE_SIZE = { width: 275, height: 182 };

export const LOGO_FULL_SX = {
  height: "77px",
  width: "fit-content",
  maxWidth: "170px",
  objectFit: "contain" as const,
};

export const LOGO_MOBILE_SX = {
  width: "35px",
  height: "35px",
  objectFit: "contain" as const,
};
